import { Link } from "react-router-dom";
import { trendingArticles } from "@/mocks/articles";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20urban%20cityscape%20at%20night%20with%20dramatic%20red%20and%20amber%20accent%20lighting%2C%20modern%20skyscrapers%20silhouettes%20against%20deep%20charcoal%20sky%2C%20neon%20glow%20reflections%20on%20wet%20asphalt%2C%20cinematic%20noir%20atmosphere%2C%20high%20contrast%20editorial%20photography%2C%20moody%20and%20intense%20aesthetic%2C%20urban%20mystery%20vibe%2C%20no%20people%20visible%2C%20abstract%20geometric%20light%20patterns&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="黑料官网 - 最新真实黑料爆料平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
            <span className="text-xs font-medium text-primary-300 font-label tracking-wide uppercase">Breaking News</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-background-50 leading-tight mb-6">
            最新真实黑料
            <br />
            <span className="text-primary-400">权威爆料平台</span>
          </h1>

          <p className="text-base md:text-lg text-background-200/80 leading-relaxed mb-8 max-w-xl">
            汇聚海量独家内幕、明星黑料、网红黑料及各类热门事件深度揭秘，第一时间为您呈现最劲爆的真相资讯。
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <Link
              to="/category/remen"
              className="px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              浏览热门爆料
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 bg-background-50/10 backdrop-blur-sm text-background-100 font-medium rounded-full hover:bg-background-50/20 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer border border-background-50/20"
            >
              了解我们
            </Link>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
          {trendingArticles.slice(0, 3).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-950/60 backdrop-blur-md border border-background-50/10 rounded-xl p-5 hover:border-primary-400/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-500/20 flex items-center justify-center mt-0.5">
                  <span className="w-5 h-5 flex items-center justify-center text-primary-400"><i className="ri-fire-line text-lg"></i></span>
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-background-100 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2 leading-snug font-heading">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-2 text-xs text-background-400">
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-eye-line"></i></span>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-chat-3-line"></i></span>
                      {article.comments}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}